import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router";
import {
  FilterState,
  ResearchId,
} from "../../adapters/deep-research/state/AppState.ts";
import { KnowledgeSource } from "../../feature-components/KnowledgeSourceDropdown/KnowledgeSourceDropdown.tsx";
import { ConnectedChatBox } from "./connected-components/ConnectedChatBox.tsx";
import styles from "./DeepResearchPage.module.css";
import { ConnectedChatMessages } from "./connected-components/ConnectedChatMessages.tsx";
import { useFiltersState } from "../../adapters/deep-research/state/hooks/stateHooks.ts";
import { useFeatureFlagValue } from "../../config/FeatureFlagManager/hooks.ts";
import { ConnectedFilterDialog } from "./connected-components/ConnectedFilterDialog.tsx";
import { ConnectedFilterChips } from "./connected-components/ConnectedFilterChips.tsx";
import { useDeepResearchService } from "../../adapters/deep-research/state/hooks/useDeepResearchService.tsx";

export const DeepResearchPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [selectedKnowledgeSource, setSelectedKnowledgeSource] = useState<
    KnowledgeSource | undefined
  >();
  const [selectedFilters, setSelectedFilters] = useState<FilterState>({});

  const appService = useDeepResearchService();
  const filterState = useFiltersState(id as ResearchId);

  useEffect(() => {
    if (!id) {
      navigate("/deep-research/new");
    }
  }, [id, navigate]);

  useEffect(() => {
    setSelectedKnowledgeSource(undefined);
    setSelectedFilters({});
  }, [id]);

  useEffect(() => {
    setSelectedFilters({});
  }, [selectedKnowledgeSource?.value]);

  useEffect(() => {
    if (id && id !== "new") {
      appService
        .refreshFilters({
          researchId: id as ResearchId,
        })
        .then();
      appService
        .refreshFilterOptions({
          researchId: id as ResearchId,
        })
        .then();
    }
  }, [appService, id]);

  useEffect(() => {
    if (id === "new" && selectedKnowledgeSource?.value) {
      appService.getFiltersByKnowledgeSource({
        knowledgeSourceName: selectedKnowledgeSource.value,
      });
    }
  }, [appService, id, selectedKnowledgeSource?.value]);

  const enableFilters = useFeatureFlagValue("enableFilters");
  const enableFilterChips = useFeatureFlagValue("enableFilterChips");

  return (
    <div className={styles.DeepResearchContainer}>
      {id && id !== "new" && (
        <ConnectedChatMessages researchId={id as ResearchId} />
      )}
      {id === "new" && (
        <div className={styles.WelcomeMessage}>
          Let's discover what you know — and what you're missing.
        </div>
      )}
      <ConnectedChatBox
        researchId={id as ResearchId}
        selectedKnowledgeSource={selectedKnowledgeSource}
        onSourceSelect={setSelectedKnowledgeSource}
        selectedFilters={selectedFilters}
        filterDialogComponent={
          enableFilters && (
            <ConnectedFilterDialog
              researchId={id as ResearchId}
              knowledgeSourceName={selectedKnowledgeSource?.value}
              initialFilters={selectedFilters}
              onFiltersChange={setSelectedFilters}
            />
          )
        }
        filterChips={
          enableFilterChips && (
            <ConnectedFilterChips
              filterState={id === "new" ? selectedFilters : filterState}
              researchId={id as ResearchId}
            />
          )
        }
      />
    </div>
  );
};
